import LotDescription from './LotDescription.jsx';

export default LotDescription;
